export default class FileEntry {
  constructor(_id, _file, _typeOfFile, _unitNumber, _referredByOHS, _tenantName, _leaseStartDate) {
    this.id = _id;
    this.file = _file;
    this.typeOfFile = _typeOfFile;
    this.unitNumber = _unitNumber;
    this.referredByOHS = _referredByOHS;
    this.tenantName = _tenantName;
    this.leaseStartDate = _leaseStartDate;
  }
}
